import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string'
import { Form } from 'react-bootstrap';

const ModuleFilterDropdown = ({ setFilter, appliedFilters, options, name }) => {
    const [value, setValue] = useState('all')
    useEffect(() => {
        setValue(((appliedFilters[name]) ? appliedFilters[name] : 'all'))
    }, [appliedFilters])
    return <>

        <Form.Group className="m-0 p-0">
            {/* <Form.Label>Recrods Per Page</Form.Label> */}
            <Form.Select
                name={name}
                value={value}
                onChange={(e) => {
                    console.log(e.target.value)
                    setFilter(name, e.target.value);
                }}
            >

                {
                    (options && options.length > 0) && (
                        options.map(({ label, value }, index) => {
                            return <option value={value} key={index}>{label}</option>
                        })


                    )

                }

                {/* <option value="all">Status</option>
                <option value="enabled">Enabled</option>
                <option value="disabled">Disabled</option> */}

            </Form.Select>
        </Form.Group>
    </>
};

export default ModuleFilterDropdown;
